module.exports = __webpack_public_path__ + "static/img/banner.144e4492.png";